import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const uniformStockList = createAsyncThunk('uniform-stock-list', async (__, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-uniform/stock-list`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const addUniformToStock = createAsyncThunk(
  'add-uniform-to-stock',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-uniform/add-uniform-to-stock`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const editUniformToStock = createAsyncThunk(
  'edit-uniform-stock',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-uniform/edit-uniform-stock/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

type UniformState = {
  errors: any
}

const initialState: UniformState = {
  errors: '',
}

export const uniformStockSlice = createSlice({
  name: 'uniform-stock',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(addUniformToStock.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = uniformStockSlice.actions
export default uniformStockSlice.reducer
